import { tickerItems } from "@/mocks/homeData";

export default function TickerBar() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <div className="marquee-wrap relative border-b border-white/10 bg-black/40 backdrop-blur">
      <div className="mx-auto flex h-11 max-w-[1400px] items-center gap-3 px-4 md:gap-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-medium text-accent-300">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-live-line animate-live-dot"></i>
          </span>
          实时更新条
        </span>
        <span className="h-4 w-px shrink-0 bg-white/15"></span>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center">
            {loopItems.map((item, index) => (
              <span key={`${item.id}-${index}`} className="flex items-center whitespace-nowrap pr-8 text-xs text-background-100/90">
                <span className="mr-2 font-mono text-[11px] text-accent-300">{item.time}</span>
                {item.text}
                <span className="ml-8 h-3 w-px bg-white/15"></span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}